<template>

    <div class="page-admin-drivers page-main">
        <slot></slot>
        <div class="page-main__content">
            <div class="app-header">
                <div class="app-header__cta">
                    <app-button
                        v-if="!isCreating"
                        theme="primary"
                        label="Create Driver"
                        @click="isCreating = true">
                    </app-button>
                </div>
            </div>

            <div class="page-admin-drivers__list">
                <driver-dashboard-item
                    v-for="driver in sortedDrivers"
                    :key="`driver-${driver.id || 'new'}`"
                    :source="driver"
                    :is-default-driver="driver.is_default === 1"
                    @set-default="setDefaultDriver"
                    @cancel="isCreating = false"
                    @update="updateDriver"
                    @remove="removeDriver">
                    <a :name="driver.id" class="hidden"></a>
                </driver-dashboard-item>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import api from '../api/drivers'
import moment from 'moment'
import DriverDashboardItem from './DriverDashboardItem.vue'

export default {
    components: { DriverDashboardItem },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            drivers: _.cloneDeep(this.items),
            isCreating: false,
            errors: { }
        }
    },
    computed: {
        sortedDrivers () {
            const sorted = _.sortBy(this.drivers, 'created_at')
            
            if (this.isCreating) {
                sorted.unshift({
                    name: '',
                    description: ''
                })
            }

            return sorted
        }
    },
    methods: {
        formatTime (ts) {
            return moment(ts).format('LLL')
        },
        updateDriver (driver) {
            const index = _.findIndex(this.drivers, { id: driver.id })
            if (index >= 0) {
                this.drivers[index] = driver
            } else {
                this.drivers.push(driver)
            }
            this.isCreating = false
        },
        removeDriver (driver) {
            const index = _.findIndex(this.drivers, { id: driver.id })
            if (index >= 0) {
                this.drivers.splice(index, 1)
            }
        },
        async setDefaultDriver (driver) {
            if (!confirm('Are you sure you want to set this driver as the default?')) {
                return
            }

            // api call to save
            const result = await api.setDefaultDriver(driver)

            if (result.errors) {
                // catch errors
                this.errors = result
            } else if (result) {
                this.drivers = result
            } else {
                console.error("Default driver update unsucessful due to a failed Axios request")
            }
        }
    }
}
</script>
